import { Situation, UnifiedMonitoringProduct } from '@hakimo-ui/hakimo/types';
import { eventTracker } from '@hakimo-ui/hakimo/util';
import { Alert, Button, Textarea } from '@hakimo-ui/shared/ui-base';
import { XCircleIcon } from '@heroicons/react/24/solid';
import { usePreEscalate } from './usePreEscalate';

interface Props {
  locationId: string;
  locationAlarmId: string;
  navToEscalation: (
    comment?: string,
    situation?: string,
    subSituation?: string
  ) => void;
  onCancel: () => void;
  selectedSituation?: Situation;
  product?: UnifiedMonitoringProduct;
}

export function PreEscalate(props: Props) {
  const { onCancel, selectedSituation } = props;

  const {
    textValue,
    onTextValueChange,
    showEmptyError,
    onEscalate,
    handleSubSituationClick,
    hasSubSituations,
    isLoading,
  } = usePreEscalate(props);

  return (
    <div className="divide-onlight-line-3 dark:divide-ondark-line-3 space-y-6 divide-y">
      <div className="pt-4 font-bold">
        This is being escalated. Please provide a brief update on the current
        situation.
      </div>

      {hasSubSituations ? (
        <div className="relative pt-6">
          <Button
            variant="icon"
            onClick={onCancel}
            className="absolute right-0 top-0"
          >
            <XCircleIcon className="h-5 w-5" />
          </Button>
          <div className="space-y-4">
            <div className="text-onlight-text-2 dark:text-ondark-text-2 font-sans text-sm font-semibold">
              {selectedSituation?.label}
            </div>
            <div className="flex flex-wrap items-start justify-start gap-2">
              {selectedSituation?.subSituations?.map((subSituation, i) => (
                <Button
                  key={i}
                  onClick={() => handleSubSituationClick(subSituation)}
                  disabled={isLoading}
                  className="p-1 px-2"
                >
                  {subSituation}
                </Button>
              ))}
            </div>
          </div>
        </div>
      ) : (
        <>
          <div className="space-y-2 pt-6">
            {showEmptyError && (
              <Alert type="error" size="small">
                Please add a comment before proceeding.
              </Alert>
            )}
            <Textarea
              onChange={onTextValueChange}
              value={textValue}
              rows={4}
              placeholder="Even a 10 word insight would do the work."
            />
          </div>
          <div className="space-x-4 pt-6 text-center">
            <Button
              variant="primary"
              onClick={onEscalate}
              loading={isLoading}
              disabled={isLoading}
              onSideEffect={eventTracker('create_location_incident')}
            >
              Proceed
            </Button>
            <Button variant="outline" onClick={onCancel}>
              Cancel
            </Button>
          </div>
        </>
      )}
    </div>
  );
}

export default PreEscalate;
